import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useExpensesStore } from '../../store/expensesStore'
import { approveExpense } from '../../utils/approveExpense'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useApproveExpenseMutation = (onSuccess?: () => void) => {
  const editExpense = useExpensesStore((state) => state.updateExpense)

  return useMutation({
    mutationFn: approveExpense,
    onSuccess: ({ message, expense }) => {
      editExpense(expense)
      toast.success(message || 'Expense approved successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while approving/rejecting the expense.',
      )
    },
  })
}
